module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M13.75 9C13.75 6.37663 11.6234 4.25 9 4.25C6.37663 4.25 4.25 6.37663 4.25 9C4.25 11.6234 6.37663 13.75 9 13.75C11.6234 13.75 13.75 11.6234 13.75 9ZM15.25 9C15.25 10.4555 14.7503 11.7932 13.916 12.8555L18.0605 17L17 18.0605L12.8555 13.916C11.7932 14.7503 10.4555 15.25 9 15.25C5.54823 15.25 2.75 12.4518 2.75 9C2.75 5.54823 5.54823 2.75 9 2.75C12.4518 2.75 15.25 5.54823 15.25 9Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
